import { severityCompareFunction, type INote } from '../../../../../../models/note.model';
import SeverityIcon from '../../../../SeverityIcon';
import BookingIcon from '../../../../BookingIcon';

function NotesIcons({ notes, className }: { notes: INote[]; className?: string }) {
  // === VARIABLES ===
  const distinctAndOrderedNotes =
    notes
      ?.filter((n1, index, array) => array.findIndex((n2) => (n2.severity === n1.severity && n1.type !== 'booking') || (n1.type === n2.type && n2.type === 'booking')) === index)
      .sort((a, b) => severityCompareFunction(a.severity, b.severity)) ?? [];

  if (distinctAndOrderedNotes.length === 0) return null;

  return (
    <ol className={`list-unstyled d-flex flex-rows ${className ?? ''}`}>
      {distinctAndOrderedNotes.map((note) => (
        <li key={note.text}>{note.type === 'booking' ? <BookingIcon /> : <SeverityIcon severity={note.severity} />}</li>
      ))}
    </ol>
  );
}

export default NotesIcons;
